/** Bump when the corresponding published text changes; retain released text in source history. */
export const TERMS_VERSION = '2026-11-05' as const;
export const PRIVACY_VERSION = '2026-11-05' as const;
